// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "logo__wrapper-2VEvB";
export { _1 as "__esModule", _2 as "logo__wrapper" }
export default { "__esModule": _1, "logo__wrapper": _2 }
